import { X } from "lucide-react";
import { UiOutlineView } from "../components/settings/UiOutlineView";

export function SettingsPanel({ open, onClose }: { open: boolean; onClose: () => void }) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      <button
        type="button"
        className="absolute inset-0 bg-black/20"
        aria-label="Close settings panel"
        onClick={onClose}
      />
      <aside className="relative flex h-full w-full max-w-4xl flex-col border-l border-border-subtle bg-card shadow-lg">
        <header className="flex items-center justify-between border-b border-border-subtle px-4 py-3">
          <div>
            <h2
              className="font-semibold text-text-primary"
              style={{ fontSize: "var(--font-heading)" }}
            >
              Settings
            </h2>
            <p className="text-text-tertiary" style={{ fontSize: "var(--font-micro)" }}>
              UI map & role visibility
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md p-1.5 text-text-secondary hover:bg-page hover:text-text-primary"
            aria-label="Close"
          >
            <X size={18} strokeWidth={1.75} />
          </button>
        </header>

        <div className="min-h-0 flex-1 overflow-y-auto p-4">
          <UiOutlineView />
        </div>
      </aside>
    </div>
  );
}
